import { render, staticRenderFns } from "./AXcontent.vue?vue&type=template&id=d23d61c2&scoped=true&"
import script from "./AXcontent.vue?vue&type=script&lang=js&"
export * from "./AXcontent.vue?vue&type=script&lang=js&"
import style0 from "./AXcontent.vue?vue&type=style&index=0&id=d23d61c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23d61c2",
  null
  
)

export default component.exports